import constants from "./constants";

const { ADMIN, COMITE, DIRESF, MERCHANT, MERCHANT_GROUP } = constants;

const privileges = [
  {
    value: constants.BAREBONE_NAVIGATION,
    roles: [COMITE],
    rolesNotAuthorized: []
  },
  {
    value: constants.FULL_NAV,
    roles: [ADMIN],
    rolesNotAuthorized: [COMITE]
  },
  {
    value: constants.REDUCED_NAV,
    roles: [MERCHANT, DIRESF],
    rolesNotAuthorized: [COMITE]
  },
  {
    value: constants.REDUCED_NAV_MERCHANT_GROUP,
    roles: [MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.CREATE_MERCHANT,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.UPDATE_FOR_ESF,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.UPDATE_FOR_MERCHANT,
    roles: [MERCHANT, DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_NAME_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_KIND_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_CODE_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_MAIN_RESORT_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_APPACCOUNTID_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_FACET_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_APPUSERID_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_EMAIL_FIELD,
    roles: [ADMIN, MERCHANT],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_NOTES_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.MERCHANT_EDIT_MERCHANT_GROUP_FIELD,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.FULL_MERCHANT_ROUTES,
    roles: [ADMIN, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.PARAMETER_MERCHANT_ROUTE,
    roles: [ADMIN, DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.IMPORT_MERCHANT_CSV_ROUTE,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.FULL_TABS_DISPLAY,
    roles: [ADMIN, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.PARAMETER_TAB_DISPLAY,
    roles: [ADMIN, DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.IMPORT_MERCHANT_CSV_TAB_DISPLAY,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.DISPLAY_SPECIFIC_PARAMETERS,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.DISPLAY_E_TICKET,
    roles: [DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.DISPLAY_MERCHANT_HEADER,
    roles: [ADMIN],
    rolesNotAuthorized: []
  },
  {
    value: constants.LISTS_REQUESTS_EXTENDED_PARAMETERS,
    roles: [ADMIN, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.LISTS_REQUESTS_KIND_PARAMETERS,
    roles: [DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_LISTS_LOAD_FILTERS,
    roles: [ADMIN, DIRESF, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.ORDER_RE_EXPORT,
    roles: [ADMIN, DIRESF, MERCHANT, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_LIST_RENDER_RESORT,
    roles: [ADMIN, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_LIST_RENDER_KIND,
    roles: [ADMIN, DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_LIST_RENDER_MERCHANTS,
    roles: [ADMIN, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_LIST_RENDER_SPACERS,
    roles: [ADMIN, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_LIST_RENDER_KIND_SPACER,
    roles: [MERCHANT_GROUP, MERCHANT],
    rolesNotAuthorized: []
  },
  {
    value: constants.SALES_SET_RESORT_LOAD_REQUEST,
    roles: [DIRESF],
    rolesNotAuthorized: []
  },
  {
    value: constants.HIDE_REFUND,
    roles: [DIRESF, MERCHANT, MERCHANT_GROUP],
    rolesNotAuthorized: [ADMIN]
  },
  {
    value: constants.DISPLAY_REFUND_BLOCK,
    roles: [ADMIN, DIRESF, MERCHANT, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.STATISTICS_SET_RESORT,
    roles: [MERCHANT],
    rolesNotAuthorized: [ADMIN, DIRESF, MERCHANT_GROUP]
  },
  {
    value: constants.STATISTICS_REDUCED_PARAMETERS,
    roles: [MERCHANT],
    rolesNotAuthorized: []
  },
  {
    value: constants.STATISTICS_EXTENDED_PARAMETERS,
    roles: [ADMIN, DIRESF, MERCHANT_GROUP],
    rolesNotAuthorized: []
  },
  {
    value: constants.STATISTICS_INIT_FILTERS,
    roles: [MERCHANT, DIRESF],
    rolesNotAuthorized: []
  }
];

const buildPrivileges = userRoles => {
  return privileges
    .filter(
      privilege =>
        privilege.roles.some(role => userRoles.indexOf(role) >= 0) &&
        privilege.rolesNotAuthorized.every(role => userRoles.indexOf(role) < 0)
    )
    .map(privilege => privilege.value);
};

const checkPrivileges = (userPrivileges, privilege) => {
  return privilege === undefined || userPrivileges.indexOf(privilege) >= 0;
};

export { buildPrivileges, checkPrivileges };



// WEBPACK FOOTER //
// ./src/auth/privileges.js